import './Panel.css'

export default {
	name: "eiis-panel",
	props: {
		header: String, icon: String, footer: Boolean, href: String, 
		border: Boolean, statusMessage: String, errorMessage: String
	},
	data: function() {
		return {
		}
	},
	methods: {
		link: function () {
			if (this.href)
				document.location.href = this.href;
			return;
		}
	},
  computed: {
		hasBorder: function() {
			return (this.border == true) ? "border": "";
		}
	},
	template: `
		<div class="eiis-panel" v-bind:class=hasBorder>
			<div class="eiis-panel-header panel-header row" v-if=header>
				<div class="eiis-panel-title col-1" v-bind:class=icon v-if=icon></div>
				<div class="eiis-panel-title col">
					{{header}}
				</div>
			</div>
			<div class="header-toolbar col d-flex justify-content-end v-if=header">
				<slot name="header"></slot>
			</div>

			<div class="eiis-panel-status alert-info" v-if=statusMessage>
				<div class="row">
					<div class="col-1">
						<i class="fas fa-info fa-2x fa-fw"></i>
					</div>
					<div class="col">
						<span v-html="statusMessage"></span>
					</div>
				</div>
			</div>
			<div class="eiis-panel-error alert-danger" v-if=errorMessage>
				<div class="row">
					<div class="col-1">
						<i class="fas fa-info fa-2x fa-fw"></i>
					</div>
					<div class="col">
						<span v-html="errorMessage"></span>
					</div>
				</div>
			</div>

			<div class="eiis-panel-content">
				<slot></slot>	
			</div>

			<div class="eiis-panel-footer d-flex flex-row-reverse" v-if=footer>
				<slot name="footer"></slot>	
			</div>
		</div>
	`
}